import React from 'react';
import styled from 'styled-components';

export const IDLE_TIMEOUT_NOTIFICATION_HEIGHT = 44

const Container = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.Navy};
  color: #F8F5FE;
  display: flex;
  font-size: 14px;
  gap: 8px;
  height: ${IDLE_TIMEOUT_NOTIFICATION_HEIGHT}px;
  justify-content: center;
  line-height: 20px;
  padding: 16px;
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoints.Tablet}) {
    padding: 12px 0px;
  }
`;

const TextContainer = styled.div`
  display: flex;  
  gap: 4px;
`;

const DesktopText = styled.span`
  display: none;

  @media (min-width: ${(props) => props.theme.breakpoints.Tablet}) {
    display: block;
  }
`;

const Icon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2797_159285)">
      <path d="M10.0013 13.3307V9.9974M10.0013 6.66406H10.0096M18.3346 9.9974C18.3346 14.5998 14.6037 18.3307 10.0013 18.3307C5.39893 18.3307 1.66797 14.5998 1.66797 9.9974C1.66797 5.39502 5.39893 1.66406 10.0013 1.66406C14.6037 1.66406 18.3346 5.39502 18.3346 9.9974Z" stroke="#F8F5FE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_2797_159285">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const IdleTimeoutNotification = () => {
  return (
    <Container>
      <Icon />

      <TextContainer>
        You have been logged out due to inactivity.
        <DesktopText>
          Please sign in below to continue.
        </DesktopText>
      </TextContainer>
    </Container>
  );
};

export default IdleTimeoutNotification;